import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { color } from '../styles/helpers/variables';

const Overlay = props => {
  if (!props.active) {
    return null;
  }
  return <OverlayElement onClick={props.onClick} opaque={props.opaque} header={props.header} />;
};

const OverlayElement = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: ${color.black};
  opacity: ${props => (props.opaque ? 1 : 0.2)};
  z-index: ${props => (props.header ? 148 : 1)};
`;

Overlay.defaultProps = {
  active: false,
  opaque: false,
  header: false,
  onClick: null
};

Overlay.propTypes = {
  onClick: PropTypes.func,
  active: PropTypes.bool,
  opaque: PropTypes.bool,
  header: PropTypes.bool
};

export default Overlay;



// WEBPACK FOOTER //
// ./src/components/Overlay.js